import { render, staticRenderFns } from "./StudentDocumentList.vue?vue&type=template&id=9409573c&"
import script from "./StudentDocumentList.vue?vue&type=script&lang=js&"
export * from "./StudentDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocumentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports